




























import { Vue, Component } from "vue-property-decorator";

interface ConfirmationDialogArgs {
  title: string;
  message: string;
  acceptMessage?: string | null;
  rejectMessage?: string | null;
  compact?: boolean;
  cancelable?: boolean;
}

@Component
export default class ConfirmationDialogComponent extends Vue {
  isShowing = false;

  title = "";
  message = "";

  acceptMessage = "";
  rejectMessage = "";

  showNegativeButton = true;
  showPositiveButton = true;
  showCompact = false;

  resolve?: (value: boolean) => void = undefined;
  reject?: (reason: string) => void = undefined;

  cancelable = true;

  async show(args: ConfirmationDialogArgs) {
    const {
      title,
      message,
      acceptMessage,
      rejectMessage,
      compact,
      cancelable,
    } = args;

    this.showCompact = compact ? true : false;
    this.cancelable = cancelable ?? true;

    this.title = title;
    this.message = message;

    this.showNegativeButton = rejectMessage !== null;
    this.showPositiveButton = acceptMessage !== null;

    this.acceptMessage = acceptMessage
      ? acceptMessage
      : this.$t("common.yes").toString();
    this.rejectMessage = rejectMessage
      ? rejectMessage
      : this.$t("common.abort").toString();

    this.isShowing = true;

    return new Promise<boolean>((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }

  onAccept() {
    this.isShowing = false;
    this.resolve && this.resolve(true);
  }

  onReject() {
    this.isShowing = false;
    this.resolve && this.resolve(false);
  }

  onInput() {
    this.resolve && this.resolve(false);
  }
}
